// live person hot fix!
// we override the Process function with the fixed version.


var livePersonHotFix2 = function () {
	this.run = window;
	this.init = function()
	{
		try {
			if (typeof(this.run.lpConnectionLibrary) != 'undefined')
			{
				// swap the function with the fixed one;
				this.run.lpConnectionLibrary.prototype.Process = this.Process2;

			}
			else
			{
				this.run.setTimeout("livePersonHotFix.init();", 5000);
				//this.run.alert(typeof(lpConnectionLibrary) + " / " + typeof(lpConnectionLibrary.Process));
				//this.run.lpConnectionLibrary.prototype.Process = this.Process;
				// try again five seconds later
			}
		} catch (e)
		{
			//this.run.alert("livepersonhotfix exception: "+ e);
		}
		
	};
	this.frames = ['bodyframe', 'easydepframe'];
	
};
var livePersonHotFix = new livePersonHotFix2(); 

livePersonHotFix.Process = function (d) {
    var dbg = (this.DebugDisplay) ? lpMTagDebug : null;
    if (d == null) {
        if (this.DebugDisplay) {
            dbg.Display('Callback No data recieved', 'ERROR', 'EMT');
        }
        return;
    }
    this.lpCallbackCnt++;
    var dRS = d.ResultSet;
    d.ServiceInfo = {};
    var dSI = d.ServiceInfo;
    if (dRS.lpCallId == 0 || dRS.lpCallId == null || dRS.lpCallId == '') {
        if (this.DebugDisplay) {
            dbg.Display('Callback No Call ID recieved', 'ERROR', 'EMT');
        }
        return;
    }
    dSI.requestType = 'REGULAR';
    dSI.resendCall = false;
    dSI.origCallId = dRS.lpCallId;
    if (typeof(dRS.lpData) != 'undefined' && typeof(dRS.lpData) == 'object' && typeof(dRS.lpData[0]) != 'undefined') {
        if (typeof(dRS.lpData[0].TYPE) != 'undefined') {
            dSI.requestType = dRS.lpData[0].TYPE;
        }
        if (typeof(dRS.lpData[0].RESEND) != 'undefined') {
            dSI.resendCall = dRS.lpData[0].RESEND;
        }
    }
    if (dSI.resendCall) {
        this.resendCounter++;
    }
    if (dSI.requestType == 'PARTIAL REQUEST') {
        dRS.lpCallId = dRS.lpCallId + '!' + dRS.lpData[0].PART;
    }
    if (this.DebugDisplay) {
        dbg.Display('Callback callId=' + dRS.lpCallId, 'DEBUG', 'EMT');
    }
    if (typeof(dRS.lpCallConfirm) == 'undefined' || dRS.lpCallConfirm == '') {
        dRS.lpCallConfirm = dRS.lpCallId;
    } else {
        dRS.lpCallConfirm += ',' + dRS.lpCallId;
    }
    var req;
    if (dSI.requestType == 'PARTIAL REQUEST' && dSI.resendCall) {
        req = this.fullForPartialQueue[dSI.origCallId];
        delete this.fullForPartialQueue[dSI.origCallId];
        if (this.DebugDisplay) {
            dbg.Display('CallId=' + dRS.lpCallId + ' Deleted - fullForPartialQueue[' + dSI.origCallId + ']', 'DEBUG', 'EMT');
        }
    } else {
        req = this.getRequestForCallId(dRS.lpCallId);
        if (req != null && req.partial) {
            req = this.fullForPartialQueue[dSI.origCallId];
        }
    }
    if (dSI.requestType != 'PARTIAL REQUEST') {
        if (this.fullForPartialQueue[dSI.origCallId]) {
            delete this.fullForPartialQueue[dSI.origCallId];
            if (this.DebugDisplay) {
                dbg.Display('CallId=' + dRS.lpCallId + ' Deleted fullForPartialQueue[' + dSI.origCallId + ']', 'DEBUG', 'EMT');
            }
        }
    }
    if (req == null) {
        if (this.DebugDisplay) {
            dbg.Display('REQUEST is NULL callId=' + dSI.origCallId, 'ERROR', 'EMT');
        }
    }
    this.confirmConnection(dRS.lpCallConfirm);
    if (dSI.requestType == 'PARTIAL REQUEST') {
        var callNum;
        var outOfcalls;
        if (typeof(dRS.lpData) != 'undefined' && typeof(dRS.lpData) == 'object') {
            if (typeof(dRS.lpData[0].PART) != 'undefined') {
                callNum = dRS.lpData[0].PART;
            }
            if (typeof(dRS.lpData[0].OUTOF) != 'undefined') {
                outOfcalls = dRS.lpData[0].OUTOF;
            }
        }
        if (dSI.resendCall) {
            for (var i = (callNum + 1); i <= outOfcalls; i++) {
                var cid = dSI.origCallId + '!' + i;
                delete this.partialQueue[cid];
            }
        } else {
            try {
                var nextCallId = dSI.origCallId + '!' + (callNum + 1);
                if (this.DebugDisplay) {
                    dbg.Display('Partial Call Response recieved  - ' + dRS.lpCallId + ' part=' + callNum + ' outof=' + outOfcalls, 'DEBUG', 'EMT');
                }
                var request = this.partialQueue[nextCallId];
                if (request != null) {
                    delete this.partialQueue[nextCallId];
                    if (request.part == request.outOf) {
                        request.callId = this.splitPartialFromStr(request.callId);
                    }
                    this.makeTheCall(request, 'get');
                } else {
                    if (typeof(dbg) != 'undefined' && dbg.Display) {
                        dbg.Display('Partial Call NOT found for id=' + nextCallId, 'ERROR', 'EMT');
                    }
                }
            } catch (e) {
                if (typeof(dbg) != 'undefined' && dbg.Display) {
                    dbg.Display('Partial Call Processing error for id=' + dRS.lpCallId + ' exception=' + e, 'ERROR', 'EMT');
                }
            }
            return;
        }
    }
    if (typeof(dRS.lpJS_Execute) != 'undefined') {
        var d_msg = [];
        for (var MTagI = 0; MTagI < dRS.lpJS_Execute.length; MTagI++) {
            var no_err_flag = true;
            var err_msg = '';
            var code_id = dRS.lpJS_Execute[MTagI].code_id;
            try {
                eval(dRS.lpJS_Execute[MTagI].js_code);
               // alert("one here!");
                // hot fix here!!! hfg
                if (code_id.indexOf("updateButton") > 0)
                {
                	var k;
                	for (k = 0; k<livePersonHotFix.frames.length; k++)
                	{
                		var frameId = livePersonHotFix.frames[k];
                	
	                	try {
	                		var elem = document.getElementById(frameId);
	                		elem.contentWindow.eval(dRS.lpJS_Execute[MTagI].js_code);
	                	} catch (exx)
	                	{
	                		
	                		// failed!
	                	}
                	}
                	//alert("executed!");
                }
                
                //end hot fix
                
                if (typeof(lpMTag) != 'undefined' && typeof(lpMTag.tmpCode) != 'undefined' && lpMTag.tmpCode != '') {
                    eval(lpMTag.tmpCode);

                }
                
            } catch (hcExecError) {
                this.lpExecuteErrors++;
                no_err_flag = false;
                err_msg = hcExecError;
            }
            if (typeof(lpMTag) != 'undefined') {
                lpMTag.tmpCode = '';
            }
            if (this.DebugDisplay) {
                if (no_err_flag) {
                    d_msg[d_msg.length] = 'OK Executed snippet=<strong>' + code_id + '</strong><!!>' + 'EXEC-OK';
                } else {
                    d_msg[d_msg.length] = 'ERROR Executing snippet=<strong>' + code_id + '</strong> &nbsp #' + err_msg + '#' + '<!!>' + 'ERROR';
                }
            }
        }
        if (this.DebugDisplay) {
            lpMTagDebug.DisplayArray(d_msg, 'EMT');
        }
    }
    if (typeof(dRS.lpCallError) != 'undefined' && this.DebugDisplay) {
        lpMTagDebug.Display('ERROR Reply Recieved=' + dRS.lpCallError + ' &nbsp # CallID = ' + dRS.lpCallId + '#', 'ERROR', 'EMT');
    }
    this.CallUsrCallbackFunc(d, req);
};

livePersonHotFix.Process2 = function (d) {
    if (d == null) {
        lpConnLib.log('Cback No data', 'ERROR', 'EMT');
        return;
    }
    this.lpCallbackCnt++;
    var dRS = d.ResultSet;
    d.ServiceInfo = {};
    var dSI = d.ServiceInfo;
    if (dRS.lpCallId == 0 || dRS.lpCallId == null || dRS.lpCallId == '') {
        lpConnLib.log('Cback No Call ID', 'ERROR', 'EMT');
        return;
    }
    dSI.requestType = 'REGULAR';
    dSI.resendCall = false;
    dSI.origCallId = dRS.lpCallId;
    if (typeof(dRS.lpData) != 'undefined' && typeof(dRS.lpData) == 'object' && typeof(dRS.lpData[0]) != 'undefined') {
        if (typeof(dRS.lpData[0].TYPE) != 'undefined') {
            dSI.requestType = dRS.lpData[0].TYPE;
        }
        if (typeof(dRS.lpData[0].RESEND) != 'undefined') {
            dSI.resendCall = dRS.lpData[0].RESEND;
        }
    }
    if (dSI.resendCall) {
        this.resendCounter++;
    }
    if (dSI.requestType == 'PARTIAL REQUEST') {
        dRS.lpCallId = dRS.lpCallId + '!' + dRS.lpData[0].PART;
    }
    lpConnLib.log('Cback cId=' + dRS.lpCallId, 'DEBUG', 'EMT');
    if (typeof(dRS.lpCallConfirm) == 'undefined' || dRS.lpCallConfirm == '') {
        dRS.lpCallConfirm = dRS.lpCallId;
    } else {
        dRS.lpCallConfirm += ',' + dRS.lpCallId;
    }
    var req;
    if (dSI.requestType == 'PARTIAL REQUEST' && dSI.resendCall) {
        req = this.fullForPartialQueue[dSI.origCallId];
        delete this.fullForPartialQueue[dSI.origCallId];
        lpConnLib.log('CId=' + dRS.lpCallId + ' Deleted - fullForPartialQueue[' + dSI.origCallId + ']', 'DEBUG', 'EMT');
    } else {
        req = this.getRequestForCallId(dRS.lpCallId);
        if (req != null && req.partial) {
            req = this.fullForPartialQueue[dSI.origCallId];
        }
    }
    if (dSI.requestType != 'PARTIAL REQUEST') {
        if (this.fullForPartialQueue[dSI.origCallId]) {
            delete this.fullForPartialQueue[dSI.origCallId];
            lpConnLib.log('CId=' + dRS.lpCallId + ' Deleted fullForPartialQueue[' + dSI.origCallId + ']', 'DEBUG', 'EMT');
        }
    }
    if (req == null) {
        lpConnLib.log('REQ is NULL callId=' + dSI.origCallId, 'ERROR', 'EMT');
    }
    this.confirmConnection(dRS.lpCallConfirm);
    if (dSI.requestType == 'PARTIAL REQUEST') {
        var callNum;
        var outOfcalls;
        if (typeof(dRS.lpData) != 'undefined' && typeof(dRS.lpData) == 'object') {
            if (typeof(dRS.lpData[0].PART) != 'undefined') {
                callNum = dRS.lpData[0].PART;
            }
            if (typeof(dRS.lpData[0].OUTOF) != 'undefined') {
                outOfcalls = dRS.lpData[0].OUTOF;
            }
        }
        if (dSI.resendCall) {
            for (var i = (callNum + 1); i <= outOfcalls; i++) {
                var cid = dSI.origCallId + '!' + i;
                delete this.partialQueue[cid];
            }
        } else {
            try {
                var ncId = dSI.origCallId + '!' + (callNum + 1);
                lpConnLib.log('P Call Response recieved  - ' + dRS.lpCallId + ' part=' + callNum + ' outof=' + outOfcalls, 'DEBUG', 'EMT');
                var r = this.partialQueue[ncId];
                if (r != null) {
                    delete this.partialQueue[ncId];
                    if (r.part == r.outOf) {
                        r.callId = this.spPartFromStr(r.callId);
                    }
                    this.makeTheCall(r, 'get');
                } else {
                    if (typeof(dbg) != 'undefined' && dbg.Display) {
                        dbg.Display('P Call NOT found for id=' + ncId, 'ERROR', 'EMT');
                    }
                }
            } catch (e) {
                if (typeof(dbg) != 'undefined' && dbg.Display) {
                    dbg.Display('P Call Proces error for id=' + dRS.lpCallId + ' exception=' + e, 'ERROR', 'EMT');
                }
            }
            return;
        }
    }
    if (typeof(dRS.lpJS_Execute) != 'undefined') {
        var d_msg = [];
        for (var MTagI = 0; MTagI < dRS.lpJS_Execute.length; MTagI++) {
            var no_err_flag = true;
            var err_msg = '';
            var code_id = dRS.lpJS_Execute[MTagI].code_id;
            try {
                eval(dRS.lpJS_Execute[MTagI].js_code);
                // hot fix here!!! hfg
                if (code_id.indexOf("updateButton") > 0)
                {
                	var k;
                	for (k = 0; k<livePersonHotFix.frames.length; k++)
                	{
                		var frameId = livePersonHotFix.frames[k];
                	
	                	try {
	                		var elem = document.getElementById(frameId);
	                		elem.contentWindow.eval(dRS.lpJS_Execute[MTagI].js_code);
	                	} catch (exx)
	                	{
	                		
	                		// failed!
	                	}
                	}
                	//alert("executed!");
                }
                
                //end hot fix
                if (typeof(lpMTag) != 'undefined' && typeof(lpMTag.tmpCode) != 'undefined' && lpMTag.tmpCode != '') {
                    eval(lpMTag.tmpCode);
                }
            } catch (hcExecError) {
                this.lpExecuteErrors++;
                no_err_flag = false;
                err_msg = hcExecError;
            }
            if (typeof(lpMTag) != 'undefined') {
                lpMTag.tmpCode = '';
            }
            if (this.DebugDisplay) {
                if (no_err_flag) {
                    d_msg[d_msg.length] = 'OK Executed snippet=<strong>' + code_id + '</strong><!!>' + 'EXEC-OK';
                } else {
                    d_msg[d_msg.length] = 'ERROR Executing snippet=<strong>' + code_id + '</strong> &nbsp #' + err_msg + '#' + '<!!>' + 'ERROR';
                }
            }
        }
        if (this.DebugDisplay) {
            lpMTagDebug.DisplayArray(d_msg, 'EMT');
        }
    }
    if (typeof(dRS.lpCallError) != 'undefined') {
        lpConnLib.log('ERR Recieved=' + dRS.lpCallError + ' &nbsp # CallID = ' + dRS.lpCallId + '#', 'ERROR', 'EMT');
    }
    this.UsrCFn(d, req);
};
define("legacy/liveperson/hotfix", function(){});

